import { useQuery } from '@tanstack/react-query';
import api from './api';

/**
 * Totaux agrégés pour /bilans (évite useAllPaiements + useAllCommandes + useAllDepenses).
 * Le backend calcule en MongoDB : commandes, CA, encaissements, reliquat, achats, dépenses, bénéfice.
 * NB : ne pas renommer ce hook sans mettre à jour Bilans.js.
 */
export const useBilanSummary = (
  boutique = null,
  startDate = null,
  endDate = null
) =>
  useQuery({
    queryKey: ['bilan', 'summary', boutique, startDate, endDate],
    queryFn: () =>
      api
        .get('/bilan/summary', {
          params: {
            boutique: boutique ?? undefined,
            startDate: startDate || undefined,
            endDate: endDate || undefined,
          },
        })
        .then((res) => res.data),
    staleTime: 1000 * 30,
  });
